import { BankAccountsActionTypes } from './action-types';
import { BankAccountView, SortParamsArg } from 'models';

export const requestBankAccounts = () =>
  ({
    type: BankAccountsActionTypes.REQUEST_BANK_ACCOUNTS_START,
  } as const);

export const requestBankAccountsSuccess = (bankAccounts: BankAccountView[]) =>
  ({
    type: BankAccountsActionTypes.REQUEST_BANK_ACCOUNTS_SUCCESS,
    payload: bankAccounts,
  } as const);

export const requestBankAccountsFailed = () =>
  ({
    type: BankAccountsActionTypes.REQUEST_BANK_ACCOUNTS_FAILED,
  } as const);

export const setBankAccountsSortParams = (params: SortParamsArg) =>
  ({
    type: BankAccountsActionTypes.SET_SORT_PARAMS,
    payload: params,
  } as const);
